import createBoundActionCreators, { createCustomCreator } from 'common/actionsBase';
import { selectHomePageAssets, selectAssets } from '../selectors';
import { retrieveHomePageAssets, retrieveAssets, downloadAssetAndUpload, retrieveAssetDetails } from './helpers';

export const types = {
  SIGN_IN: 'US_SIGN_IN',
  SIGN_OUT: 'US_SIGN_OUT',
  SET_RESULTS_RETRIEVE_START: 'US_SET_RESULTS_RETRIEVE_START',
  SET_RESULTS_RETRIEVE_END: 'US_SET_RESULTS_RETRIEVE_END',
  SET_RESULTS_RETRIEVE_SUCCESS: 'US_SET_RESULTS_RETRIEVE_SUCCESS',
  RETRIEVE_HOME_PAGE_ASSETS: 'US_RETRIEVE_HOME_PAGE_ASSETS',
  SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS: 'US_SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS',
  SELECT_ASSETS: 'US_SELECT_ASSETS',
  RETRIEVE_ASSETS: 'US_RETRIEVE_ASSETS',
  CLEAR_RESULTS: 'US_CLEAR_RESULTS',
  CLEAR_SEARCH_PHRASE: 'US_CLEAR_SEARCH_PHRASE',
  CLEAR_FILTERS: 'US_CLEAR_FILTERS',
  SET_SEARCH_PARAMS: 'US_SET_SEARCH_PARAMS',
  TOGGLE_FILTERS_PANEL: 'US_TOGGLE_FILTERS_PANEL',
  SELECT_ASSETS_FORMAT: 'US_SELECT_ASSETS_FORMAT',
  UPLOAD: 'US_UPLOAD',
  RETRIEVE_ASSET_DETAILS: 'US_RETRIEVE_ASSET_DETAILS',
  RETRIEVE_ASSET_DETAILS_SUCCESS: 'US_RETRIEVE_ASSET_DETAILS_SUCCESS',
  UPLOAD_START: 'US_UPLOAD_START',
  UPLOAD_END: 'US_UPLOAD_END',
  CLEAR_FORMAT: 'US_CLEAR_FORMAT',
};

export default createBoundActionCreators(types, {
  [types.RETRIEVE_HOME_PAGE_ASSETS]: createCustomCreator(async (dispatch, getState, dispatcher) => {
    const state = getState();
    const { assetsInProgress } = selectHomePageAssets(state);
    if (!assetsInProgress) {
      await retrieveHomePageAssets(dispatch, getState, dispatcher);
    }
  }),
  [types.RETRIEVE_ASSETS]: createCustomCreator(async (payload, dispatch, getState, dispatcher) => {
    const state = getState();
    const { assetsInProgress } = selectAssets(state);
    if (!assetsInProgress) {
      await retrieveAssets(payload, dispatch, getState, dispatcher);
    }
  }),
  [types.UPLOAD]: createCustomCreator(async (payload, dispatch, getState, dispatcher) => {
    await downloadAssetAndUpload(payload, dispatch, getState, dispatcher);
  }),
  [types.RETRIEVE_ASSET_DETAILS]: createCustomCreator(async (payload, dispatch, getState, dispatcher) => {
    await retrieveAssetDetails(payload, dispatch, getState, dispatcher);
  }),
});
